import Collapse from 'react-bootstrap/Collapse';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { NavamsaChart } from './NavamsaChart';
import { RashiChart } from './RashiChart';
import { RashiPlanetChart } from './RashiPlanetChart';

export function RashiChartTab ({menuArray,birthHouseData,navamsaHouseData,planetaryPositionData,userData,clientData,birthChartType,setBirthChartType}) {
  return(
  <>
    <Collapse in={menuArray[0]} className="m-0 p-0 ">
      <Row id="rashiChartTab" className="m-0 p-0">
          <Col xs={12} lg={4} className="m-0 p-2 pt-0 pagebreakportrait">
            <RashiChart birthHouseData={birthHouseData} userData={userData} clientData={clientData} birthChartType={birthChartType} setBirthChartType={setBirthChartType} kpenabled={false}/>
          </Col>
          <Col xs={12} lg={4} className="m-0 p-2 pt-0 pagebreakportrait">
            <NavamsaChart navamsaHouseData={navamsaHouseData} userData={userData} clientData={clientData}/>
          </Col>
          <Col xs={12} lg={4} className="m-0 p-2 pt-0">
            <RashiPlanetChart planetaryPositionData={planetaryPositionData} userData={userData}/>
          </Col>
      </Row>
    </Collapse>
  </>  
  );
}